<template>
  <div class="field">
    <Field
      :name="id"
      :rules="rules"
      v-slot="{ field, errors }"
      :modelValue="modelValue"
    >      

      <label v-if="label" class="label" :for="id">
        <span v-html="label"></span>
        <RequiredAsterisk v-if="rules.includes('required')" />
      </label>

      <div class="control">

        <div class="select is-fullwidth" :class="{ 'is-danger': !!errors.length }">

          <select
            :id="id"
            v-bind="field"
            @change="updateValue($event.target.value)"
          >
            <option disabled value="">Select...</option>

            <option
              v-for="option in options"
              :value="option"
              :key="option"
            >
              {{ option }}
            </option>

          </select>

        </div>

      </div>

      <p v-if="errors.length" class="help is-danger">
        {{ errors[0] }}
      </p>
      
    </Field>
  </div>
</template>

<script>
import { Field } from 'vee-validate';
import RequiredAsterisk from '@/components/forms/required-asterisk.vue';

export default {
  name: 'SelectElement',
  props: {
    id: {
      type: String,
      required: true,
      validator: value => value.length,
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    rules: {
      type: String,
      default: ''
    },
    errorMsg: {
      type: String,
      default: 'Not valid'
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    }
  },
  components: {
    RequiredAsterisk,
    Field,
  },
};
</script>